export default __webpack_public_path__ + "static/media/image_11.44d5aa19.jpg";